import React, { useState } from "react";
import "./PalmaresSection.css";
import { FaTrophy, FaMedal, FaStar, FaAward } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const palmaresData = [
    {
        period: "2024 - 2025",
        achievements: [
            { text: "Champion du Championnat Régional 1 (2024/2025)", icon: <FaTrophy /> },
            { text: "Montée en D2 Futsal (2024/2025)", icon: <FaStar /> },
        ],
    },
    {
        period: "2021 - 2023",
        achievements: [
            { text: "Première saison en D2 Futsal (2021/2022)", icon: <FaMedal /> },
            { text: "Champion de Régional 2 (2022/2023)", icon: <FaTrophy /> },
            { text: "Champion Départemental District 44 (2022/2023)", icon: <FaTrophy /> },
        ],
    },
    {
        period: "2018 - 2020",
        achievements: [
            { text: "Champion Régional 1 (2018/2019)", icon: <FaTrophy /> },
            { text: "Montée en D2 Nationale (2019/2020)", icon: <FaStar /> },
            { text: "9ᵉ de finale Coupe Nationale Futsal (2019/2020)", icon: <FaStar /> },
        ],
    },
    {
        period: "2016 - 2018",
        achievements: [
            { text: "Champion Régional 1 (2016/2017)", icon: <FaTrophy /> },
            { text: "Vainqueur de la Coupe Pays de la Loire (2017/2018)", icon: <FaMedal /> },
        ],
    },
    {
        period: "2009 - 2015",
        achievements: [
            { text: "Champion Départemental District 44 (2011/2012)", icon: <FaTrophy /> },
            { text: "Champion Régional U16/U13 (2014/2015)", icon: <FaMedal /> },
            { text: "Création du club (2008)", icon: <FaStar /> },
        ],
    },
];

const PalmaresSection = () => {
    // Tri des données par ordre chronologique croissant (Ancien -> Récent)
    const getStartYear = (period) => {
        const match = period.match(/^(\d{4})/);
        return match ? parseInt(match[1], 10) : 0;
    };

    // a - b pour ordre croissant
    const sortedPalmares = [...palmaresData].sort((a, b) => getStartYear(a.period) - getStartYear(b.period));

    const sliderSettings = {
        dots: true,
        infinite: false, // On désactive l'infini pour avoir une fin claire
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 640,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    const PalmaresCard = ({ item }) => (
        <div className="palmares-card-content">
            <h3 className="palmares-period">{item.period}</h3>
            <div className="palmares-divider"></div>
            <ul className="palmares-list">
                {item.achievements.map((ach, i) => (
                    <li key={i}>
                        <span className="palmares-icon">{ach.icon}</span>
                        {ach.text}
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <section className="palmares-section">
            <div className="section-header-row">
                <h2 className="section-title">Palmarès & Distinctions</h2>
                {/* Sélecteur de vue supprimé - Mode Carrousel unique */}
            </div>

            <motion.div
                initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                className="palmares-carousel-container"
            >
                <Slider {...sliderSettings}>
                    {sortedPalmares.map((item, index) => (
                        <div key={index} className="carousel-slide-wrapper">
                            <PalmaresCard item={item} />
                        </div>
                    ))}
                </Slider>

                {/* Label Jeunes Futsal Excellence */}
                <div className="recompense-section-integrated">
                    <div className="recompense-header">
                        <FaAward className="recompense-icon" />
                        <h2 className="recompense-title">Label Jeunes Futsal Excellence</h2>
                        <p className="recompense-period">2023 - 2026</p>
                    </div>
                    <div className="recompense-content-columns">
                        <div className="recompense-img-wrapper">
                            <img
                                src="/images/labelFFF.webp"
                                alt="Label Jeunes Futsal Excellence"
                                className="recompense-image"
                            />
                        </div>
                        <div className="recompense-description text-left">
                            <p>
                                <strong>Label Jeunes FFF Crédit Agricole</strong> est une distinction
                                décernée dans le cadre de la politique fédérale d'accompagnement des clubs
                                par la FFF. Ce label représente une véritable distinction nationale,
                                visant à récompenser les clubs les plus méritants en matière de structuration.
                            </p>
                            <p>
                                Le label met en avant les efforts du club pour promouvoir le futsal et
                                développer des pratiques éducatives et sportives de haute qualité.
                            </p>
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};

export default PalmaresSection;
